/** Ukrainian mobile: 0XXXXXXXXX or 380XXXXXXXXX → +38 (0XX) XXX-XX-XX */
export function formatPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  const full = digits.startsWith('38') ? digits : `38${digits}`;
  if (full.length === 12) {
    return `+${full.slice(0, 2)} (${full.slice(2, 5)}) ${full.slice(5, 8)}-${full.slice(8, 10)}-${full.slice(10)}`;
  }
  return raw;
}

export function phoneHref(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  return `tel:+${digits.startsWith('38') ? digits : `38${digits}`}`;
}
